
import ReactApexChart from "react-apexcharts";
import { useTheme } from "@mui/material/styles";
import { useSubscriptionGrowth } from "../../hooks/useSubscriptions";
import { CircularProgress, Box } from "@mui/material";

const ApexChart2 = ({ year = 'all', month = 'all' }) => {
    const theme = useTheme();
    const { data: growthData, isLoading, error } = useSubscriptionGrowth({ year, month });

    const barColor = "#00dec3";
    const labelColor = theme.palette.text.primary; 
    const isDarkMode = theme.palette.mode === "dark";

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <CircularProgress />
            </Box>
        );
    }

    if (error || !growthData?.data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height={350}>
                <div style={{ color: labelColor }}>Failed to load growth data</div>
            </Box>
        );
    }

    const { growth, labels } = growthData.data;

    const series = [
        {
            name: "New Subscriptions",
            data: growth || [],
        }
    ];

    const options = {
        chart: {
            height: 350,
            type: "bar",
            background: "transparent",
            zoom: { enabled: false },
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                columnWidth: '60%',
                distributed: false,
            }
        },
        theme: {
            mode: isDarkMode ? "dark" : "light",
        },
        dataLabels: { enabled: false },
        stroke: { 
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: [barColor],
        xaxis: {
            categories: labels || [],
            labels: {
                style: {
                    colors: labelColor,
                },
            },
        },
        yaxis: {
            labels: {
                style: {
                    colors: labelColor,
                },
            },
        },
        tooltip: {
            theme: isDarkMode ? "dark" : "light",
            y: {
                formatter: function (val) {
                    return val + " subscriptions"
                }
            }
        },
        legend: {
            show: false
        },
        grid: {
            borderColor: isDarkMode ? "#444" : "#e7e7e7",
            strokeDashArray: 4,
        },
    };

    return (
        <Box height={350}>
            <ReactApexChart
                options={options}
                series={series}
                type="bar"
                height="100%"
            />
        </Box>
    );
};

export default ApexChart2;
